import React, { useEffect, useRef, useState } from "react";

const VoiceWaveform = ({ stream, isRecording, isPaused }) => {
  //  added isPaused
  const canvasRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);
  const animationIdRef = useRef(null);
  const sourceRef = useRef(null);
  const timerRef = useRef(null);

  const [secondsElapsed, setSecondsElapsed] = useState(0);

  useEffect(() => {
    if (!stream || !isRecording) return;
    // reset time only when recording starts fresh:
    if (secondsElapsed === 0) setSecondsElapsed(0);
    startTimer();

    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    audioContextRef.current = audioCtx;
    const analyser = audioCtx.createAnalyser();
    analyser.fftSize = 2048;
    analyserRef.current = analyser;

    const dataArray = new Uint8Array(analyser.fftSize);
    dataArrayRef.current = dataArray;

    const source = audioCtx.createMediaStreamSource(stream);
    sourceRef.current = source;
    source.connect(analyser);

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const draw = () => {
      animationIdRef.current = requestAnimationFrame(draw);
      if (isPaused) return; //  pause drawing

      analyser.getByteTimeDomainData(dataArray);
      ctx.fillStyle = "#f5f5f5";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.lineWidth = 2;
      ctx.strokeStyle = "#2196f3";
      ctx.beginPath();

      const sliceWidth = canvas.width / analyser.fftSize;
      let x = 0;
      for (let i = 0; i < analyser.fftSize; i++) {
        const v = dataArray[i] / 128.0;
        const y = (v * canvas.height) / 2;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
        x += sliceWidth;
      }
      ctx.lineTo(canvas.width, canvas.height / 2);
      ctx.stroke();
    };
    draw();

    return () => {
      cancelAnimationFrame(animationIdRef.current);
      clearInterval(timerRef.current);
      source.disconnect();
      analyser.disconnect();
      audioCtx.close();
    };
  }, [stream, isRecording, isPaused]); //  depend on isPaused

  //  Pause/Resume timer dynamically
  useEffect(() => {
    if (isPaused) {
      clearInterval(timerRef.current);
    } else if (isRecording && !isPaused) {
      startTimer();
    }
  }, [isPaused]);

  const startTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setSecondsElapsed((prev) => prev + 1);
    }, 1000);
  };

  const formatTime = (seconds) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <div style={{ marginTop: "16px" }}>
      <canvas
        ref={canvasRef}
        width={400}
        height={100}
        style={{
          width: "100%",
          height: "80px",
          borderRadius: "8px",
          backgroundColor: "#fff",
        }}
      />
      <div
        style={{
          marginTop: "8px",
          textAlign: "center",
          fontWeight: "bold",
          color: isPaused ? "gray" : "black",
        }}
      >
        ⏱️ {formatTime(secondsElapsed)} {isPaused && "(Paused)"}
      </div>
    </div>
  );
};

export default VoiceWaveform;
